import React from "react";

interface LeftChevronProps {
  width?: number;
  height?: number;
  color?: string;
}

const LeftChevron = ({
  width = 14,
  height = 14,
  color = "#1F1F1F",
}: LeftChevronProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 3.5L5.25 7L8.75 10.5"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LeftChevron;
